import React, { type SVGProps } from "react";
import { iconSizes, type IconProps } from "./utils/shared";
const SortDesc = (props: SVGProps<SVGSVGElement> & IconProps) => (
  <svg
    viewBox="0 0 24 24"
    fill="currentColor"
    xmlns="http://www.w3.org/2000/svg"
    width={props.size ? iconSizes[props.size] : iconSizes["s"]}
    height={props.size ? iconSizes[props.size] : iconSizes["s"]}
    title="SortDesc"
    {...props}
  >
    <path d="M20 4V16H23L19 21L15 16H18V4H20ZM12 18V20H3V18H12ZM14 11V13H3V11H14ZM14 4V6H3V4H14Z" />
  </svg>
);
export default React.memo(SortDesc);
